
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reklama-v-fitnes-klubah/[slug]",
      function () {
        return require("private-next-pages/reklama-v-fitnes-klubah/[slug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reklama-v-fitnes-klubah/[slug]"])
      });
    }
  